
namespace TabAurous.Retail {
    import fld = POSSalesLaborRow.Fields;
    @Serenity.Decorators.registerClass()
    export class POSSalesItemsDialog extends _Ext.ItemEditorDialog<POSSalesItemsRow> {
        protected getFormKey() { return POSSalesItemsForm.formKey; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        public form = new POSSalesItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            //Set Numeric Fields as Right Align

            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.hideEditorToolbar(this.form.BOMDetails);

            this.form.Pieces.changeSelect2(e => {
                if (this.form.HasBom.value)
                    this.CalculateTotals();
                else
                    this.CalculateRate();
            });

            this.form.Weight.changeSelect2(e => {
                if (!isNaN(this.form.Weight.value)) {

                    var lbr = this.form.LaborDetails.getItems();
                    var self = this;
                    lbr.forEach(function (x) {
                        x.Weight = self.form.Weight.value;
                        x.Pieces = self.form.Pieces.value;
                        x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                    });

                    this.form.LaborDetails.setItems(lbr);
                    this.CalculateRate();
                }

            });

            this.form.UnitRate.changeSelect2(e => {
                if (this.form.UnitRate.value != null)
                    this.CalculateRate();
            });

            this.form.CalcOnId.changeSelect2(e => {
                if (this.form.CalcOnId.value != "")
                    this.CalculateRate();
            });

            this.form.NetAmount.changeSelect2(e => {
                if (this.form.NetAmount.value != null)
                    this.form.GrossAmount.value = this.form.Pieces.value * this.form.NetAmount.value;
            });

            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });

            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item

            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });
            this.form.MF.changeSelect2(e => {
                var mfamount = this.form.GrossAmount.value / this.form.MF.value;
                var item = RateHelper.ReCalculateMarkUp(this.form.MF.value, mfamount, this.form.BOMDetails.getItems(), this.form.LaborDetails.getItems(), this.form.Pieces.value, this.form.Weight.value, this.form.NetWeight.value
                    , this.form.FancyCharges.value, this.form.OtherCharges.value);
                var bomdetails = item.BOMDetails;
                this.form.BOMDetails.setItems(bomdetails);
                this.form.LaborDetails.setItems(item.LaborDetails);
                this.CalculateTotals();

            });

            this.form.StoneRate.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.StoneWeight.changeSelect2(e => {
                this.form.StoneAmount.value = this.form.StoneWeight.value * this.form.StoneRate.value;
                this.CalculateRate();
            });

            this.form.Discount.changeSelect2(e => {
                var discount = this.form.Discount.value;

                var labordetails = this.form.LaborDetails.getItems();
                for (var l = 0; l < labordetails.length; l++) {
                    delete labordetails[l]["__id"];
                    delete labordetails[l]["RowNum"];
                }
                Common.CommonService.GetItemDiscount({
                    Discount: discount,
                    LaborDetails: labordetails
                }, response => {
                    var x = response;
                    if (response.Entities == null) {
                        q.Alert('', 'Discount Policies will be affected, cannot apply Discount', 2999, true);
                        this.form.Discount.value = 0;
                        this.form.DiscountPer.value = 0;
                        return;
                    }
                    if (response.Entities.length > 0) {
                        var labors = response.Entities;
                        this.form.LaborDetails.setData(labors);
                        this.form.GrossAmount.value = this.form.GrossAmount.value - discount;
                        this.form.DiscountPer.value = (discount / this.form.NetAmount.value) * 100;
                        //this.form.LaborDetails.setData(labors);
                    }
                    this.CalculateTotals();
                }, { async: false })
            });
        }


        getItem() {
            return this.getSaveEntity()
        }


        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.ItemMaster = (this.parentEditor.parentDialog as POSSalesDialog);
            this.RateListId = this.ItemMaster.RateListId;
            this.LaborListId = this.ItemMaster.LaborListId;
            this.StoneMarkup = this.ItemMaster.StoneMarkup;
            this.StoneDiscount = this.ItemMaster.StoneDisount;
            this.ExchangeRate = this.ItemMaster.ExchangeRate;
            this.PartyId = parseInt(this.ItemMaster.form.PartyId.value);
            this.TransDate = this.ItemMaster.entity.TransDate;
            ItemFieldHelper.SalesItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
        }

    }
}